import React, { useState } from 'react';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { ReactComponent as DeleteEmoji } from 'assets/icons/delete-emoji.svg';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';

type FormDataType = {
  id?: string;
  name: string;
  active: boolean;
  brand_ids: string[];
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onDelete?: () => void;
  data: FormDataType;
};
const DeleteScreenModal = ({ isOpen, onClose, onDelete, data }: Props) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await apiService.delete(`kitchen/screens/${data?.id ?? ''}`, {
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      onDelete?.();
      toast(<ToastMessage type='success' message='Screen deleted successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal isOpen={isOpen} onRequestClose={onClose} title=''>
      <div className='flex flex-col justify-center items-center mb-[12px]'>
        <DeleteEmoji />
        <p className='font-medium text-[18px] mb-3'>Delete {data.name}?</p>

        <p className='text-sm text-[#6F7376] text-center mb-4'>
          Are you sure you want to delete this screen
        </p>
      </div>
      <div className='w-[103%] ml-[-1rem] pl-2 pt-[24px] flex justify-between'>
        <Button variant='outline' color='primary' className='mr-4 h-[49px]' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='block'
          color='primary'
          loading={loading}
          className='h-[49px]'
          onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </BaseModal>
  );
};

export default DeleteScreenModal;
